import { Fragment, useState, useEffect } from 'react'
import styles from './phone-input.module.css'
import Countries from "@/data/countries.json";

export default function PhoneInput({ dial_code, height, margin_bottom, tab_index, updateMobileNumber, country_id }){
	const [dialCode, setDialCode] = useState(dial_code);
	const [mobileNumber, setMobileNumber] = useState('');
	const [completeInput, setCompleteInput] = useState('');
	const [showCountryList, setShowCountryList] = useState(false);
	const [selectedCountryCode, setSelectedCountryCode] = useState('');
	const [placeholder, setPlaceholder] = useState('');

	useEffect(() => { 
		if( window.location.hostname === "www.intix.com.au" ){ 
			setSelectedCountryCode('au');
			setDialCode(61);
		} else if( window.location.hostname === "www.intix.co.nz" ){
			setSelectedCountryCode('nz');
			setDialCode(64);
		} else if( window.location.hostname === "www.intix.co.uk" ){
			setSelectedCountryCode('uk');
			setDialCode(44);
		} else {
			setSelectedCountryCode('us');
			setDialCode(1);
		}
	}, []);

	useEffect(() => { 
		if( Countries.some( a => a.iso3166 == selectedCountryCode ) ){
			const obj = Countries.find( a => a.iso3166 == selectedCountryCode );
			setSelectedCountryCode( obj.iso3166.toLowerCase() );
			setPlaceholder( obj.placeholder );
		}
	 }, [selectedCountryCode]);

	function selectCountry(country_code, dial_code_x, placeholder_x){
		setShowCountryList(!showCountryList);
		setDialCode(dial_code_x);
		setSelectedCountryCode(country_code);
		setPlaceholder(placeholder_x);
   	}

   	function updateMobileNumberValue(e){
   		setMobileNumber(e.trim());
   		if( showCountryList === true ){ setShowCountryList(false); }
   		updateMobileNumber(dialCode + e.replace(/\D/g,''));
   	}

	return (
		<div className={styles.inputDiv} style={{height:height,marginBottom:margin_bottom}}>
			<div style={{position:'relative'}}>
				<div className={styles.border} style={{height:height}}>
					<div className={styles.areaCode} style={{height:height}}>
						<div className={styles.selectContainer}>
							<div className={styles.flagSelect}>
								<button className={styles.flagSelectButton} onClick={e => setShowCountryList(!showCountryList)}>
									<div className={styles.selector}>
										<div className={styles.selectDropdown}>
											<div className={styles.selectFlagIcon}><img src={"https://d2jun3ty2bmcrf.cloudfront.net/website/img/flags/" + selectedCountryCode + ".svg"} /></div>
											<div className={styles.selectFlagName} style={{lineHeight:height}}>+{dialCode}</div>
											<div className={styles.selectDropdownIcon}>&nbsp;</div>
										</div>
									</div>
								</button>
							</div>
						</div>
						{ showCountryList ?( 
							<div className={styles.countryDropdown}>
								<div className={styles.countryList}>
									<ul className={styles.countryOl}>
										{Countries.map((item, index) => ( 
											<li className={styles.countryListItem} data-dial-code={item.dial_code} data-country-code={item.iso3166} onClick={e => selectCountry(item.iso3166,item.dial_code,item.placeholder)} key={item.iso3166}>
												<div className={styles.countrySelectFlagBox}><img src={"https://d2jun3ty2bmcrf.cloudfront.net/website/img/flags/" + item.iso3166.toLowerCase() + ".svg"} /></div>
												<div className={styles.countrySelectName}>{item.name}</div>
												<div className={styles.countrySelectDialCode}>+{item.dial_code}</div>
											</li>
										))}
									</ul>
								</div>
							</div>
						) : null}
					</div>
					<input type="text" className={styles.phoneInput} value={mobileNumber} onChange={e => updateMobileNumberValue(e.target.value)} minLength="6" maxLength="20" inputMode="numeric" pattern="\d*" style={{height:height, lineHeight:height}} placeholder={placeholder} tabIndex={tab_index} required />
				</div>
			</div>
		</div>
	)
}